import { reactive } from 'vue'
import { nav_race_query, nav_race_save } from '@/server/modules/44018.js'
import { message } from 'ant-design-vue'

export const useNavigation = searchParams => {
  const state = reactive({
    keyArr: [],
    keyPC: {},
    keyM: {},
    keyApp: {},
    getKey: (data, id) => {
      const result = data.filter(e => e.subChannel - 0 === id)[0]
      return {
        ...result,
        subChannel: id,
        switchKey: result?.switchKey - 0 === 1 ? true : false
      }
    },
    getRaceInfo() {
      nav_race_query(searchParams).then(({ success, data, retInfo }) => {
        if (success) {
          if (searchParams.terminalId === 1) {
            state.keyM = state.getKey(data.keys, 2)
            state.keyPC = state.getKey(data.keys, 1)
          }
          if (searchParams.terminalId === 2) {
            state.keyApp = state.getKey(data.keys, -1)
          }
          state.visible = true
        } else {
          message.error(retInfo)
        }
      })
    },
    saveRace() {
      const terminalMap =
        searchParams.terminalId === 1
          ? [state.keyM, state.keyPC]
          : [state.keyApp]
      const params = {
        keys: terminalMap.map(e => {
          return {
            ...e,
            switchKey: e.switchKey ? 1 : 0
          }
        }),
        ...searchParams
      }

      nav_race_save(params).then(({ success, retInfo }) => {
        if (success) {
          message.success('保存成功')
          state.visible = false
        } else {
          message.error(retInfo)
        }
      })
    },
    visible: false,
    checked1: false,
    checked: false,
    handleSetting: async () => {
      await state.getRaceInfo()
    },
    handleOk: async () => {
      await state.saveRace()
    }
  })
  return state
}
